import { FC } from 'react'

const EllipsisVertical: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  fill,
  height,
  width,
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M12 4C11.175 4 10.5 4.675 10.5 5.5C10.5 6.325 11.175 7 12 7C12.825 7 13.5 6.325 13.5 5.5C13.5 4.675 12.825 4 12 4ZM12 17C11.175 17 10.5 17.675 10.5 18.5C10.5 19.325 11.175 20 12 20C12.825 20 13.5 19.325 13.5 18.5C13.5 17.675 12.825 17 12 17ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z'
        fill={fill || '#1D1D1F'}
      />
    </svg>
  )
}

export default EllipsisVertical
